import type { OrderItem } from "../../types";

/**
 * HA-600 AC6 — the product's prep time on a line the kitchen has, as the till shows it: "≈ 8 mins".
 * Taken by the server when the line was sent, so it's absent on an unsent line and on one whose
 * product has no prep time.
 */
export function prepTimeLabel(
	item: Pick<OrderItem, "sentToKitchen" | "preparationTime">,
): string | null {
	const minutes = item.preparationTime;
	if (!item.sentToKitchen || minutes == null || minutes <= 0) return null;

	return `≈ ${minutes} ${minutes === 1 ? "min" : "mins"}`;
}
